<main class="w-full">
	<cdk-tree [dataSource]="dataSource ?? []" [treeControl]="treeControl">
		<cdk-nested-tree-node *cdkTreeNodeDef="let node" class="tree-node">
			<div class="tree-node-body">
				<span class="expand-icon leaf-node"></span>
				<div class="tree-node-content">
					<ng-container *ngTemplateOutlet="content; context: node"></ng-container>
				</div>
			</div>
		</cdk-nested-tree-node>

		<cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="tree-node">
			<div class="tree-node-body cursor-pointer" cdkTreeNodeToggle>
				<span class="expand-icon" [class.rotate-180]="treeControl.isExpanded(node)">
					<lbca-icon name="lucide:chevron-down"></lbca-icon>
				</span>
				<div class="tree-node-content">
					<ng-container *ngTemplateOutlet="content; context: node"></ng-container>
				</div>
			</div>

			<div [class.tree-invisible]="!treeControl.isExpanded(node)">
				<ng-container cdkTreeNodeOutlet></ng-container>
			</div>
		</cdk-nested-tree-node>
	</cdk-tree>
</main>

<ng-template #content let-data="data">
	@for (col of field?.configuration?.primary; track col) {
		<div
			[style.min-width.px]="col.minWidth"
			[style.flex]="'0 0 ' + (col.size / 12) * 100 + '%'"
			[style.max-width]="!col.flexGrow && (col.size / 12) * 100 + '%'"
			[style.flex-grow]="col.flexGrow"
		>
			@if (!col.editable || (col.editable && !canEditAssignedUser)) {
				<lbca-input-text
					[label]="col?.label"
					[disabled]="true"
					[referenced]="true"
					[value]="formatterValue(data[col?.entityKey]) || '-'"
				></lbca-input-text>
			}
			@if (col.editable && canEditAssignedUser) {
				<lbca-select-rounded
					class="w-full"
					[data]="data[col?.entityKey]"
					[label]="col?.label"
					[options]="data.options"
					[require]="true"
					[dataSave]="true"
					[labeled]="false"
					[disabled]="data.status !== 'Atribuído'"
					(changeValue)="changeValue($event, data.id, data.status !== 'Atribuído')"
					[value]="data[col?.entityKey]?.id"
				></lbca-select-rounded>
			}
		</div>
	}

	@if (field?.configuration?.secondary?.length) {
		<div
			class="z-10 text-gray-600 transition duration-400 ease-in-out cursor-pointer"
			[class.rotate-180]="data.opened"
			(click)="toogleCollapse($event, data)"
		>
			<lbca-icon name="lucide:chevron-down"></lbca-icon>
		</div>
	}

	@if (data.opened) {
		<div class="w-full">
			@for (col of field?.configuration?.secondary; track col) {
				@if (!data[col?.entityKey] || (col?.type || 'TEXT') === 'TEXT') {
					<lbca-input-text
						[style.min-width.px]="col.minWidth"
						[style.flex]="'0 0 ' + (col.size / 12) * 100 + '%'"
						[style.max-width]="!col.flexGrow && (col.size / 12) * 100 + '%'"
						[style.flex-grow]="col.flexGrow"
						[label]="col?.label"
						[disabled]="true"
						[referenced]="true"
						[value]="data[col?.entityKey] || '-'"
					></lbca-input-text>
				}
				@if (data[col?.entityKey] && col?.type === 'TEXTAREA') {
					<lbca-textarea
						[style.min-width.px]="col.minWidth"
						[style.flex]="'0 0 ' + (col.size / 12) * 100 + '%'"
						[style.max-width]="!col.flexGrow && (col.size / 12) * 100 + '%'"
						[style.flex-grow]="col.flexGrow"
						[label]="col?.label"
						[disabled]="true"
						[value]="data[col?.entityKey] || '-'"
					></lbca-textarea>
				}
			}
		</div>
	}
</ng-template>
